import ExcelJS from "exceljs";

const PrimaryExcelDownloadHandler = async (subject, topics, primaryLanguage) => {
    const workbook = new ExcelJS.Workbook(); // Create a new workbook
    const worksheet = workbook.addWorksheet("Quiz Template"); // Add a worksheet to the workbook
    console.log(topics, "pxl topics");

    const options1 = ["Option 1", "Option 2", "Option 3", "Option 4"];
    const correctOptions = ["a", "b", "c", "d"];
    const difficulty = ["1", "2", "3", "4"];

    console.log('topics', topics);

    // Add headers to the sheet (First row filled with headers)
    worksheet.getCell("A1").value = "PrimaryLanguage";
    worksheet.getCell("B1").value = "Topic";
    worksheet.getCell("C1").value = "Question";
    worksheet.getCell("D1").value = "Option A";
    worksheet.getCell("E1").value = "Option B";
    worksheet.getCell("F1").value = "Option C";
    worksheet.getCell("G1").value = "Option D";
    worksheet.getCell("H1").value = "Correct Option";
    worksheet.getCell("I1").value = "Correct Option Explanation";
    worksheet.getCell("J1").value = "Difficulty";

    // Fill the first data row (row 2) with default values
    worksheet.getCell("A2").value = primaryLanguage || "english"; // Default language
    worksheet.getCell("B2").value = topics[0]; // Default topic
    worksheet.getCell("C2").value = "Your Question"; // Empty question field
    worksheet.getCell("D2").value = options1[0]; // Default option 1
    worksheet.getCell("E2").value = options1[1]; // Default option 2
    worksheet.getCell("F2").value = options1[2]; // Default option 3
    worksheet.getCell("G2").value = options1[3]; // Default option 4
    worksheet.getCell("H2").value = correctOptions[0]; // Default correct option
    worksheet.getCell("I2").value = "Enter explanation"; // Default explanation
    worksheet.getCell("J2").value =1; // Default difficulty level

    worksheet.dataValidations.add("A2:A1000", {
        type: "list",
        allowBlank: false,
        formulae: [`"${primaryLanguage}"`], // Dynamic list of languages
        showErrorMessage: true,
        errorTitle: "Invalid Entry",
        error: "Please select a valid language from the list",
    });

    // Add dropdown validation for the "Topic" column (B2:B1000)
    worksheet.dataValidations.add("B2:B1000", {
        type: "list",
        allowBlank: false,
        formulae: [`"${topics?.join(',')}"`], // Dynamic list of topics
        showErrorMessage: true,
        errorTitle: "Invalid Entry",
        error: "Please select a valid topic from the list",
    });

    // Add dropdown validation for the "Correct Option" column (H2:H1000)
    worksheet.dataValidations.add("H2:H1000", {
        type: "list",
        allowBlank: false,
        formulae: [`"${correctOptions.join(',')}"`], // Dynamic list of correct options
        showErrorMessage: true,
        errorTitle: "Invalid Selection",
        error: "Please select a valid option from the list",
    });

    // Add dropdown validation for the "Difficulty" column (J2:J1000)
    worksheet.dataValidations.add("J2:J1000", {
        type: "list",
        allowBlank: false,
        formulae: [`"${difficulty.join(',')}"`], // Dynamic list of difficulty levels
        showErrorMessage: true,
        errorTitle: "Invalid Selection",
        error: "Please select a valid difficulty level from the list",
    });

    // Write the Excel file and trigger download
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "quiz_template.xlsx";
        link.click();
    });
};

export default PrimaryExcelDownloadHandler;
